export const toRequestMethod = (method: string | undefined): string => (method || 'GET').toUpperCase()

export const toRequestInfo = (request: RequestInfo | URL): string => {
  if (typeof request === 'string') return request
  if (request instanceof URL) return request.toString()
  return request.url
}

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms))
